import { z } from 'zod';

/** Pre-filled buyer information passed into checkout. */
const sdkPrefilledInfoSchema = z.object({
    buyerFullName: z.string().optional(),
    buyerPhone: z.string().optional(),
    buyerEmail: z.string().email().optional(),
});
/** Why an availability check came back unavailable. */
const SDK_AVAILABILITY_REASONS = {
    OUT_OF_STOCK: 'out_of_stock',
    NOT_FOUND: 'not_found',
    NOT_PURCHASABLE: 'not_purchasable',
    CONFIG_DISABLED: 'config_disabled',
    OUT_OF_MARKET_AREA: 'out_of_market_area',
    /** The submitted `zip` is not a well-formed US ZIP, so no market area was evaluated. */
    INVALID_ZIP: 'invalid_zip',
    /** The vehicle is sellable, but the cart itself failed the checkout pipeline. */
    INVALID_CART: 'invalid_cart',
};
/**
 * Availability outcomes the SDK reports to analytics: every reason the BFF
 * returns, plus `errored` for a request that never returned one.
 */
const SDK_AVAILABILITY_REPORTED_REASONS = {
    ...SDK_AVAILABILITY_REASONS,
    ERRORED: 'errored',
};
/** Which vehicle identifier an availability check resolved on; the BFF prefers the URL. */
const SDK_AVAILABILITY_IDENTIFIER_TYPES = {
    VEHICLE_DETAILS_URL: 'vehicle_details_url',
    PRODUCT_ID: 'product_id',
};
/** Error codes returned by the checkout SDK. */
const CHECKOUT_SDK_ERROR_CODES = {
    VALIDATION_ERROR: 'VALIDATION_ERROR',
    NETWORK_ERROR: 'NETWORK_ERROR',
    RATE_LIMITED: 'RATE_LIMITED',
    NOT_FOUND: 'NOT_FOUND',
    UNAUTHORIZED: 'UNAUTHORIZED',
    SERVER_ERROR: 'SERVER_ERROR',
    /** Checkout is not usable for this tenant: no configured checkout domain, or the SDK config never enabled the capability. */
    CHECKOUT_UNAVAILABLE: 'CHECKOUT_UNAVAILABLE',
    /** The resolved vehicle isn't cleared for online sale (e.g. not live, reserved, or its owner has checkout disabled). */
    VEHICLE_UNAVAILABLE: 'VEHICLE_UNAVAILABLE',
};

export { CHECKOUT_SDK_ERROR_CODES, SDK_AVAILABILITY_IDENTIFIER_TYPES, SDK_AVAILABILITY_REASONS, SDK_AVAILABILITY_REPORTED_REASONS, sdkPrefilledInfoSchema };
//# sourceMappingURL=SdkCheckout.js.map
